import { DOW, MON } from './portalWindow';

/**
 * The bits an event element prints, from whatever row the composer or the viewer holds
 * (a search row, a `fromEvent` card, or the reel's `sourceEvent`). Handoff §5.4.
 */
const clean = (s) => String(s || '').trim();

/** A short name: the title up to its first comma, colon, dash or " at ", 28 characters at most. */
export function shortTitle(title) {
  const t = clean(title);
  const cut = t.split(/\s[–—-]\s|[,:]|\sat\s/i)[0].trim() || t;
  return cut.length > 28 ? `${cut.slice(0, 27).trim()}…` : cut;
}

/** `8 PM` · `7:30 PM`. */
export function shortTime(d) {
  const h = d.getHours();
  const m = d.getMinutes();
  const hh = h % 12 || 12;
  const ap = h < 12 ? 'AM' : 'PM';
  return m ? `${hh}:${String(m).padStart(2, '0')} ${ap}` : `${hh} ${ap}`;
}

export function eventBits(event, now = new Date()) {
  if (!event) return null;
  const title = clean(event.title);
  const iso = event.startsAtUtc || event.dateTimeUtc || event.startUtc || null;
  const d = iso ? new Date(iso) : null;
  const valid = d && !Number.isNaN(d.getTime());
  const today = valid && d.toDateString() === now.toDateString();
  const place = clean(event.place || event.locationCity || event.locationLabel || event.venueName || '');
  const when = valid
    ? (today ? `TODAY, ${shortTime(d)}` : `${DOW[d.getDay()]} ${MON[d.getMonth()]} ${d.getDate()}, ${shortTime(d)}`)
    : '';
  return {
    id: event.id || event.eventId || null,
    title,
    short: event.short || shortTitle(title),
    mon: valid ? (today ? 'TODAY' : MON[d.getMonth()]) : '',
    day: valid ? (today ? '●' : String(d.getDate())) : '',
    time: valid ? shortTime(d) : '',
    place,
    meta: [when, place.toUpperCase()].filter(Boolean).join(' · ') || clean(event.meta).toUpperCase(),
    href: event.href || (event.inviteCode ? `/events/${event.inviteCode}` : null),
  };
}
